import { render, staticRenderFns } from "./DvFade.vue?vue&type=template&id=85888860&"
import script from "./DvFade.vue?vue&type=script&lang=ts&"
export * from "./DvFade.vue?vue&type=script&lang=ts&"
import style0 from "./DvFade.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports